import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { LOCATION_PROP_TYPE } from '../constants/propTypes';
import { ITEMS_PROP_TYPE } from './tabs/constants';

import Tabs from './tabs/Tabs';

import withStickyBehavior from './withStickyBehavior';

import './StickyTabs.scss';

const NABVAR_HEIGHT = 72;

class StickyTabs extends Component {
    static propTypes = {
        items: ITEMS_PROP_TYPE,
        onTabChange: PropTypes.func,
        onTabLoad: PropTypes.func,
        initialSelectedTab: PropTypes.string,
        location: LOCATION_PROP_TYPE,
    };

    render() {
        const {
            items,
            onTabChange,
            onTabLoad,
            initialSelectedTab,
            location,
        } = this.props;

        return (
            <Tabs
                items={items}
                onTabChange={onTabChange}
                onTabLoad={onTabLoad}
                initialSelectedTab={initialSelectedTab}
                location={location}
            />
        );
    }
}

export default withStickyBehavior(StickyTabs, { topAdjust: NABVAR_HEIGHT });
